  <template>
  <v-form ref="frmCadastro">
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model.trim="$v.user.email.$model"
            prepend-icon="mdi-email"
            name="email"
            autocomplete="off"
            :error-messages="emailError"
            label="E-mail"
            ref="inptemail"
            type="email"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model.trim="$v.user.codigo.$model"
            prepend-icon="mdi-server"
            name="codigo"
            autocomplete="off"
            :error-messages="codigoError"
            label="Código"
            type="text"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            :append-icon="showPwdBd ? 'mdi-eye-off' : 'mdi-eye'"
            :type="showPwdBd ? 'text' : 'password'"
            @click:append="showPwdBd = !showPwdBd"
            v-model.trim="$v.user.password.$model"
            :error-messages="passwordError"
            prepend-icon="mdi-lock"
            name="password"
            label="Senha"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            :append-icon="showPwdBdRepeat ? 'mdi-eye-off' : 'mdi-eye'"
            :type="showPwdBdRepeat ? 'text' : 'password'"
            @click:append="showPwdBdRepeat = !showPwdBdRepeat"
            v-model.trim="$v.user.repassword.$model"
            :error-messages="repasswordError"
            prepend-icon="mdi-lock"
            name="repassword"
            label="Repita a Senha"
          />
        </v-col>
        <v-spacer />
        <v-col cols="12" class="col-12 d-flex justify-lg-space-between">
          <v-btn large @click.prevent="voltar"> Voltar </v-btn>
          <v-btn
            :disabled="$v.$invalid || disableSubmit ? true : false"
            color="primary"
            large
            type="submit"
            @click.prevent="submit"
          >
            Cadastrar
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
import { required, email, minLength, sameAs } from 'vuelidate/lib/validators'
export default {
  name: 'Cadastro',
  data: () => ({
    user: {
      email: '',
      codigo: '',
      password: '',
      repassword: ''
    },
    showPwdBd: false,
    showPwdBdRepeat: false,
    disableBtn: false
  }),
  validations: {
    user: {
      email: {
        required,
        email
      },
      codigo: {
        required,
        minLength: minLength(36)
      },
      password: {
        required,
        minLength: minLength(6)
      },
      repassword: {
        required,
        sameAsPassword: sameAs('password')
      }
    }
  },
  computed: {
    emailError () {
      const errors = [];
      const email = this.$v.user.email;
      if (!email.$dirty) {
        return errors;
      }
      !email.required && errors.push('E-email é obrigatório')
      !email.email && errors.push('E-email inválido')
      return errors;
    },
    codigoError () {
      const errors = [];
      const item = this.$v.user.codigo
      if (!item.$dirty) {
        return errors;
      }
      !item.required && errors.push('Código é obrigatório')
      !item.minLength && errors.push('Código é obrigatório')
      return errors;
    },
    passwordError () {
      const errors = [];
      const password = this.$v.user.password;
      if (!password.$dirty) {
        return errors;
      }
      !password.required && errors.push('Senha é obrigatório')
      !password.minLength && errors.push(`Senha deve conter ${password.$params.minLength.min} caracteres`)
      return errors;
    },
    repasswordError () {
      const errors = [];
      const password = this.$v.user.repassword;
      if (!password.$dirty) {
        return errors;
      }
      !password.required && errors.push('Senha é obrigatorio')
      !password.sameAsPassword && errors.push(`As Senha devem ser iguais `)
      return errors;
    },
    disableSubmit: {
      set (value) {
        this.disableBtn = value
      },
      get () {
        return this.disableBtn
      }
    }
  },
  methods: {
    voltar () {
      this.$emit('action', { page: 1, content: { email: this.user.email } })
    },
    submit () {
      this.disableSubmit = true
      let data = {
        user: this.user.email,
        hostId: this.user.codigo,
        pwd: this.$alertme.md5(this.user.password),
        mod:[999]
      };
      this.$store.dispatch('btnMsg','continuar o cadastro')
      this.$alertme.createUser(data)
        .then(res => {
          this.disableSubmit = false
          if (res.data.message.toLowerCase() == 'ok') {
            this.$store.dispatch('MsgSucces', 'Cadastro efetuado')
            this.$store.dispatch('displayMsgSuccess', true)
            // this.$emit('action', { page: 1 })
            this.$emit('action', { page: 1, content: { email: this.user.email } })
            this.$refs.frmCadastro.reset()
          } else {
            this.$store.dispatch('setMsgError', res.data.message)
            this.$store.dispatch('setDisplayMsgErr', true)
          }
        },
          () => {
            this.disableSubmit = false
          })
    }
  }
}
</script>